import { Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { MatIcon } from '@angular/material/icon';
import { MatMenuItem } from '@angular/material/menu';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-access-error',
  templateUrl: './access-error.component.html',
  imports: [TranslocoPipe, MatIcon, MatMenuItem, RouterLink],
  styleUrl: './access-error.component.scss',
})
export class AccessErrorComponent {}
